<template>
  <div class="container share">
    <!-- 标题 -->
    <section class="header">资源服务</section>

    <!-- tabs -->
    <section class="tabs-wrap">
      <div
        class="tab"
        v-for="item in tabs"
        :key="item.id"
        :class="{ 'tab--selected': item.selected }"
        @click="onTabChange(item)"
      >
        {{ item.label }}
      </div>
    </section>

    <!-- table 区域 -->
    <Card class="table-wrap" v-show="tabPoint.data.length">
      <!-- 发布按钮 -->
      <Button class="table-btn" type="warning" @click.native="toPublish()"
        >发布</Button
      >

      <!-- 表格 -->
      <Table
        id="table"
        :columns="tabPoint.columns"
        :data="tabPoint.data"
        :loading="tableLoading"
        stripe
        border
        @on-row-dblclick="onRowDBClick"
      ></Table>

      <!-- 分页 -->
      <Page
        class="table-page"
        :current="tabPoint.pageNum"
        :total="tabPoint.dataTotal"
        :page-size="tabPoint.pageSize"
        show-total
        @on-change="onPageNumChange"
      />
    </Card>

    <Card v-if="!tabPoint.data.length" class="table-wrap table-nodata">
      <img
        class="table-nodata_img"
        src="../../../assets/images/share/placeholder-nodata.png"
      />
      <p class="table-nodata_text">暂无{{ tabPoint.name }}</p>
      <p class="table-nodata_text">快去发布吧</p>
      <Button type="warning" @click.native="toPublish()">发布</Button>
    </Card>
  </div>
</template>

<script>
/* 定义选项构造函数 */
class Tab {
  constructor({
    id,
    name,
    resourceType,
    columns = [],
    data = [],
    dataTotal = 0
  } = {}) {
    this.id = id;
    this.resourceType = resourceType;
    this.name = name;
    this.pageNum = 1;
    this.pageSize = 10;

    this.columns = columns;
    this.data = data;
    this.dataTotal = dataTotal;

    this._tabChangeRequest = true; // tab 切换时是否发起请求
  }
}

// tab id 常量
const TABID_1 = "demand"; // 需求清单
const TABID_2 = "share"; // 共享资源
const TABID_3 = "service"; // 服务项目

// table 配置
const COLUMN_CONFIG = {
  columnNum: 5, // table 总列数
  columnWidth: 300, // table 默认列宽
  [TABID_1]: function() {
    return [
      // {
      //   title: "名称",
      //   key: "title",
      //   resizable: true,
      //   width: this.columnWidth
      // },
      {
        title: "需求方",
        key: "applicant",
        resizable: true,
        width: this.columnWidth
      },
      {
        title: "联系方式",
        key: "phone",
        resizable: true,
        width: this.columnWidth
      },
      {
        title: "需求描述",
        key: "content",
        resizable: true,
        width: this.columnWidth,
        tooltip: true
      }
    ];
  },
  [TABID_2]: function() {
    return [
      {
        title: "名称",
        key: "title",
        resizable: true,
        width: this.columnWidth
      },
      {
        title: "负责人",
        key: "applicant",
        resizable: true,
        width: this.columnWidth
      },
      {
        title: "联系方式",
        key: "phone",
        resizable: true,
        width: this.columnWidth
      },
      {
        title: "资源描述",
        key: "content",
        resizable: true,
        width: this.columnWidth,
        tooltip: true
      }
    ];
  },
  [TABID_3]: function() {
    return [
      {
        title: "名称",
        key: "title",
        resizable: true,
        width: this.columnWidth
      },
      {
        title: "负责人",
        key: "applicant",
        resizable: true,
        width: this.columnWidth
      },
      {
        title: "联系方式",
        key: "phone",
        resizable: true,
        width: this.columnWidth
      },
      {
        title: "资源描述",
        key: "content",
        resizable: true,
        width: this.columnWidth,
        tooltip: true
      }
    ];
  }
};
export default {
  name: "share-list",
  components: {},
  props: {},
  data() {
    return {
      tableLoading: false,
      tabs: [
        {
          id: TABID_1,
          label: "需求清单",
          resourceType: 26, // 后台对应的字段
          selected: true
        },
        {
          id: TABID_2,
          label: "共享资源",
          resourceType: 27,
          selected: false
        },
        {
          id: TABID_3,
          label: "服务项目",
          resourceType: 28,
          selected: false
        }
      ],
      tabPoint: new Tab() // tab对象指针
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 跳转到发布 默认 新增模式
    toPublish(
      extra = {
        edit: 1
      }
    ) {
      this.$router.push({
        path: "/userManager/share/publish",
        query: {
          title: this.tabPoint.name,
          resourceType: this.tabPoint.resourceType,
          ...extra
        }
      });
    },
    // 选项卡切换
    onTabChange(cur) {
      this.tabs.forEach(item => (item.selected = false));
      cur.selected = true;

      // 修改指针指向
      this.tabPoint = this[cur.id];

      // 第一次切换时请求
      if (this.tabPoint._tabChangeRequest) this.getList();
    },
    // 双击某一行
    onRowDBClick(e) {
      this.toPublish({
        id: e.id,
        detail: 1
      });
    },
    // 初始化表单的操作配置
    initTableAction() {
      return {
        title: "操作",
        key: "action",
        render: (h, params) => {
          return h(
            "div",
            {
              class: "share_action-wrap",
              on: {
                click: e => {
                  let cur = this.tabPoint.data[params.index];
                  if (e.target.dataset.type === "detail") {
                    this.toPublish({
                      id: cur.id,
                      detail: 1
                    });
                  }
                  if (e.target.dataset.type === "edit") {
                    this.toPublish({
                      id: cur.id,
                      edit: 1
                    });
                  }
                  if (e.target.dataset.type === "delete") {
                    this.$Modal.confirm({
                      title: "提示",
                      content: `确定要删除 <b class="share_del-modal_content">${cur.title || ''}</b> 吗?`,
                      onOk: () => {
                        this.deleteItem(cur);
                      }
                    });
                  }
                }
              }
            },
            [
              h("div", {
                class: "share_action-item",
                attrs: {
                  "data-type": "detail"
                },
                domProps: {
                  innerHTML: "详情"
                }
              }),
              h("div", {
                class: "share_action-item",
                attrs: {
                  "data-type": "edit"
                },
                domProps: {
                  innerHTML: "编辑"
                }
              }),
              h("div", {
                class: "share_action-item",
                attrs: {
                  "data-type": "delete"
                },
                domProps: {
                  innerHTML: "删除"
                }
              })
            ]
          );
        }
      };
    },
    // 初始化 tab 对象
    initTab() {
      // 计算列宽
      let table = document.getElementById("table");
      COLUMN_CONFIG.columnWidth = table.clientWidth / COLUMN_CONFIG.columnNum;

      // 根据tab 初始化对象
      this.tabs.forEach(item => {
        this[item.id] = new Tab({
          id: item.id,
          name: item.label,
          resourceType: item.resourceType,
          columns: [...COLUMN_CONFIG[item.id](), this.initTableAction()]
        });

        // 初始化指针
        if (item.selected) this.tabPoint = this[item.id];
      });
    },
    // 切换分页
    onPageNumChange(e) {
      this.tabPoint.pageNum = e;
      this.getList();
    },
    // 获取列表
    getList({ refresh = false } = {}) {
      // 从第一页开始加载
      if (refresh) this.tabPoint.pageNum = 1;

      let { pageNum, pageSize, resourceType } = this.tabPoint;

      this.showTabLoading();
      this.$post(this.urlobj.share_list, {
        pageNum,
        pageSize,
        resourceType
      })
        .then(res => {
          // 对返回数据格式化并扩展
          this.tabPoint.data = res.rows.map(item => ({
            id: item.id,
            title: item.title,
            applicant: item.userName,
            phone: item.userPhoneNO,
            content: item.remark,
            ...item
          }));
          // 更新总数
          this.tabPoint.dataTotal = res.total;
          // 更新切换请求开关
          if (this.tabPoint._tabChangeRequest)
            this.tabPoint._tabChangeRequest = false;
        })
        .finally(this.hideTableLoading);
    },
    // 删除 列表
    deleteItem(cur) {
      this.showTabLoading();
      let url = this.urlobj.share_delete + `?idList=${[cur.id]}`;
      this.$delete(url)
        .then(() => {
          this.$Message.success("删除成功");
          this.getList({ refresh: true });
        })
        .finally(this.hideTableLoading);
    },
    // 显示table loading
    showTabLoading() {
      this.tableLoading = true;
    },
    // 隐藏table loading
    hideTableLoading() {
      this.tableLoading = false;
    }
  },
  created() {},
  mounted() {
    this.initTab();
  },
  activated() {
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.container {
  .flex(@flexDirection:column);
  height: 100%;
  padding: 20px;
}
.header {
  color: #666;
  font-size: 25px;
  text-align: center;
  margin-bottom: 20px;
}

.tabs-wrap {
  .flex();
}
.tab {
  padding: 6px 10px;
  margin: 0 10px;
  color: #4b4b4b;
  font-size: 16px;
  font-weight: 600;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
}
.tab--selected {
  color: #fff;
  background-color: #ff7b44;
}

.table-wrap {
  flex: 1;
  position: relative;
  text-align: right;
}
.table-nodata {
  .flex(center, @flexDirection:column);
  text-align: center;

  &_img {
    width: 400px;
    height: 300px;
    margin-top: 80px;
  }
  &_text {
    font-size: 16px;
    color: #ff7b44;
    letter-spacing: 6px;
    margin: 16px 0;
  }
}
.table-btn {
  margin-bottom: 20px;
}
.table-page {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
</style>

<style lang="less">
/* render action style & it will be golbal css*/
.share_action-wrap {
  .flex(center, @flexWrap:wrap);
}
.share_action-item {
  position: relative;
  font-size: 14px;
  color: #5e6d94;
  margin: 0 12px;
  white-space: nowrap;
  cursor: pointer;

  &::before {
    content: "[";
    position: absolute;
    left: -6px;
    transition: left 0.1s ease-in-out;
  }
  &::after {
    content: "]";
    position: absolute;
    right: -6px;
    transition: right 0.1s ease-in-out;
  }

  &:hover {
    &::before {
      left: -10px;
    }
    &::after {
      right: -10px;
    }
  }
}
.share_del-modal_content {
  color: #f43f3e;
}
</style>
